import {BreakpointObserver} from '@angular/cdk/layout';
import {Component, OnInit} from '@angular/core';
import {ResponsiveMode} from '../../../models/responsive-mode.type';
import {SassHelperComponent} from '../../../providers/sass-helper/sass-helper.component';

@Component({
  selector: 'morva-sso-error',
  templateUrl: './sso-error.component.html',
  styleUrls: ['./../error.scss'],
})
export class SsoErrorComponent implements OnInit {
  responsiveMode: ResponsiveMode;
  private sassHelper: SassHelperComponent;

  constructor(private breakPointObserver: BreakpointObserver) {
    this.sassHelper = new SassHelperComponent();
  }

  ngOnInit(): void {
    this.breakPointObserver.observe([this.sassHelper.mdMaxWidth]).subscribe(state => {
      if (state.breakpoints[this.sassHelper.mdMaxWidth]) {
        this.responsiveMode = 'md';
      } else {
        this.responsiveMode = 'lg';
      }
    });
  }
}
